import React from "react";

export default function KeyMembers() {
  return (
    <div className="atae-contacts-list contacts-list">
      <h2 className="font-bold text-lg mb-8">ATAE Key Contacts</h2>

      <div className="contact-list-item sm:auto mb-8 pb-8 border-b border-gray-500 justify-between items-center">
        <div className="mb-4 sm:mb-2 flex flex-50 flex-grow items-center">
          <div className="flex-shrink-0 cover-image w-16 h-16 mr-8">
            <img src="/sites/default/files/media/images/ATAE-Logo-150x150-for-Media-Contact.gif" alt="ATAE" width={"150"} height={"150"} loading={"lazy"}/>
          </div>
          <div>
            <p className="text-xl leading-none">
              Automotive Trade Association Executives
            </p>
          </div>
        </div>
        <div className="ml-24 media-contact__details text-lg leading-tight mt-2">
          <a className="text-gray-700 no-underline block" href="#">8484 Westpark Drive, Suite 500
            Tysons, VA 22102</a>

        </div>
      </div>
      <div className="contact-list-item sm:auto mb-8 pb-8 border-b border-gray-500 justify-between items-center">
        <div className="mb-4 sm:mb-2 flex flex-50 flex-grow items-center">
          <div className="flex-shrink-0 cover-image w-16 h-16 mr-8">
            <img src="https://www.nada.org/sites/default/files/styles/thumbnail/public/media/images/jennifer-colman.png?itok=-utQ2jG5" alt="Jennifer Colman" />
          </div>
          <div>
            <p className="text-xl leading-none">
              Jennifer Colman
              <span className="media-contact__position mt-1 space-y-2 block">
                <span className="block text-xxs text-gray-700 leading-none">ATAE President</span>
              </span>
            </p>
          </div>
        </div>
        <div className="ml-24 media-contact__details text-lg leading-tight mt-2">
          <a className="text-gray-700 no-underline block" href="tel:703.821.7071">703.821.7071 (office)</a>
          <a className="text-gray-700 no-underline block" href="tel:202.320.3228">202.320.3228 (mobile)</a>
          <a className="text-gray-700 no-underline block" href="mailto:jcolman@nada.org">jcolman@nada.org</a>
        </div>
      </div>
    </div>
  );
}
